import { createCache } from '@bldsoft/cappie/transport/http/cache'
import { indexedDbStore } from '@bldsoft/cappie/transport/http/cache/indexed-db'
import { memoryStore } from '@bldsoft/cappie/transport/http/cache/memory'
import { i18nCacheRule } from '@setplex/tria-api-adapter-nora'

// temporary migration cleanup: i18n responses moved into cappie's IndexedDB cache
localStorage.removeItem('tria__v3-i18n-cache__old')

/**
 * HTTP response cache: middleware composed outside the Request Policy so
 * hits do not consume the policy budget, and a controller to drop subscriber
 * entries when the session changes.
 *
 * Only requests which opt in are cached: subscriber scoped ones through
 * `meta.cache` in the adapter, and translations through their own rule,
 * which needs a durable store to survive a restart.
 */
export const { middleware: withCache, controller: cacheController } =
  createCache({
    defaultStore: memoryStore({ maxEntries: 128 }),
    rules: [i18nCacheRule(indexedDbStore({ maxEntries: 1 }))],
  })
